import { isResource } from 'src/containers/ProjectDiagram/utils/data';
import { Project } from 'src/store/state/projects';

const stripVolatile = (p: Project) => {
  const { dateLastUpdated: _dateLastUpdated, diagram, ...rest } = p;
  const { id: _diagramId, ...diagramRest } = diagram || {};
  return { ...rest, diagram: diagramRest };
};

export const pruneDeletedProjectResources = (project: Project): Project => {
  if (!project?.diagram?.model) {
    return project;
  }

  const resourceIds = new Set(
    project.diagram.model.nodeDataArray
      .filter((nodeData) => isResource(nodeData))
      .map((nodeData) => nodeData.value)
  );

  const fileUploadsById = { ...project.fileUploadsById };
  const virtualGraphsById = { ...project.virtualGraphsById };

  Object.keys(fileUploadsById).forEach((fileUploadId) => {
    if (!resourceIds.has(fileUploadId)) {
      delete fileUploadsById[fileUploadId];
    }
  });

  Object.keys(virtualGraphsById).forEach((virtualGraphId) => {
    if (!resourceIds.has(virtualGraphId)) {
      delete virtualGraphsById[virtualGraphId];
    }
  });

  return {
    ...project,
    fileUploadsById,
    virtualGraphsById,
  };
};

// Whether a cloud project's persisted content changed between two snapshots,
// ignoring volatile fields (timestamps, diagram id). Shared by the legacy save
// path in cloudProjectMiddleware and the Y.Doc write path in
// collaborationMiddleware so both decide "did anything worth persisting change?"
// identically.
export const hasProjectChanged = (
  oldProject: Project | undefined,
  prunedProject: Project
): boolean =>
  Boolean(
    oldProject?.isCloudProject &&
      JSON.stringify(stripVolatile(prunedProject)) !==
        JSON.stringify(stripVolatile(pruneDeletedProjectResources(oldProject)))
  );
